import { Demographic } from './demographic';
import { MemberPhoneInformation } from './entity-contact-information';
import { MemberAddress } from './member-address';
import { MemberPreference } from './member-preference';

export class Individual {
  individualId: number;
  uniqueId: string;
  rin: string;
  mrn: string;
  firstName: string;
  lastName: string;
  dob: Date;
  email: string;
  sex = 'UNK';
  mobileNo: string;
  phoneNo: string;
  ethnicity: string = null;
  race: string = null;
  language: string = null;
  community: string;
  economicStatus: string;
  resident: number;
  dod: Date; // Date of death
  orgId: number;
  photoURL: string;
  orgLevel: number;
  country = 'USA';
  privatekey: string;
  userexists: boolean;
  waivercode: string[];
  zipcode: string = null;
  alternatephno: string;
  emergencycontactname: string;
  contactpersonrelation: string;
  contactpersonphone: string;
  calculatedAge: string;
  addedby: number;
  modifiedby: number;
  timezone: string = null;
  preferredPhoneNumber: string;
  agree: boolean;
  demographic: Demographic[];
  addresses: Demographic[];
  age: string;
  sexOther: string = null;
  memberAddresses: MemberAddress[];
  preferredpronoun: string;
  preferredPronounOther: string;
  preferredMemberName: string;
  preferredLang: string;
  preferredLangOther: string;
  preferredGender: string;
  preferredGenderOther: string;
  preferredEmail: string;
  preferredContactMethod: string;
  memberPhoneInformation: MemberPhoneInformation[];
  preferredPhoneRelation: string;
  memberPreference: MemberPreference[];
  employer: string;
  sexArr: string[] = [];
}
